import { useAuth } from "@onefront/react-sdk";
import React, { useEffect, useState } from "react";
import { useGetAssets } from "../../../../hooks/api/utilities/useGetAssets";
import { useGetNation } from "../../../../hooks/api/utilities/useGetNation";
import { useGetUtilities } from "../../../../hooks/api/utilities/useGetUtilities";
import { useBrowserStorage } from "../../../../hooks/useBrowserStorage";
import { generateHeaders } from "../../../../utils/generate-headers";
import { useCurrentTenant } from "@drift/oneplatfront";

export const AuthProviders = ({ children }) => {
    const { get: getCountries, set: setCountries } = useBrowserStorage("countries");
    const { get: getRegions, set: setRegions } = useBrowserStorage("regions");
    const { get: getProvinces, set: setProvinces } = useBrowserStorage("provinces");
    const { get: getZipCodes, set: setZipCodes } = useBrowserStorage("zipcodes");
    const { get: getCities, set: setCities } = useBrowserStorage("cities");
    const { get: getDugs, set: setDugs } = useBrowserStorage("dugs");
    const { get: getCurrencies, set: setCurrencies } = useBrowserStorage("currencies");
    const { get: getAssets, set: setAssets } = useBrowserStorage("assets");

    const { loading: loadingRegion, fetch: fetchRegions } = useGetNation("regions", "IT");
    const { loading: loadingProvinces, fetch: fetchProvinces } = useGetNation("provinces", "IT");
    const { loading: loadingZipCodes, fetch: fetchZipCodes } = useGetNation("zipcodes", "IT");
    const { loading: loadingCities, fetch: fetchCities } = useGetNation("cities", "IT");
    const { loading: loadingDugs, fetch: fetchDugs } = useGetNation("spaceTypes", "IT");

    const { loading: loadingAssets, fetch: fetchAssets } = useGetAssets("getGroups");
    const { loading: loadingCurrencies, fetch: fetchCurrencies } = useGetUtilities("currencies", {}, true);

    const [hasError, setHasErrors] = useState(false);
    const auth = useAuth();
    const { tenant } = useCurrentTenant(true);

    useEffect(() => {
        if (!getCountries()) {
            setCountries([
                { value: "IT", label: "Italia" },
                { value: "CH", label: "Svizzera" },
                { value: "ES", label: "Spagna" },
                { value: "SM", label: "San Marino" }
            ]);
        }
    }, [getCountries, setCountries]);

    useEffect(() => {
        if (!hasError && tenant?.itemId && !getRegions() && !loadingRegion) {
            fetchRegions({
                headers: generateHeaders(auth?.tokenData, tenant?.itemId, tenant?.id)
            })
                .then(res => {
                    setRegions(res?.data);
                })
                .catch(() => setHasErrors(true));
        }
    }, [getRegions, setRegions, fetchRegions, hasError, loadingRegion, auth, tenant]);

    useEffect(() => {
        if (!hasError && tenant?.itemId && !getProvinces() && !loadingProvinces) {
            fetchProvinces({
                headers: generateHeaders(auth?.tokenData, tenant?.itemId, tenant?.id)
            })
                .then(res => {
                    setProvinces(res?.data);
                })
                .catch(() => setHasErrors(true));
        }
    }, [getProvinces, setProvinces, fetchProvinces, hasError, loadingProvinces, auth, tenant]);

    useEffect(() => {
        if (!hasError && tenant?.itemId && !getZipCodes() && !loadingZipCodes) {
            fetchZipCodes({
                headers: generateHeaders(auth?.tokenData, tenant?.itemId, tenant?.id)
            })
                .then(res => {
                    setZipCodes(res?.data);
                })
                .catch(() => setHasErrors(true));
        }
    }, [getZipCodes, setZipCodes, fetchZipCodes, hasError, loadingZipCodes, auth, tenant]);

    useEffect(() => {
        if (!hasError && tenant?.itemId && !getCities() && !loadingCities && auth?.tokenData) {
            fetchCities({
                headers: generateHeaders(auth?.tokenData, tenant?.itemId, tenant?.id)
            })
                .then(res => {
                    setCities(res?.data);
                })
                .catch(() => setHasErrors(true));
        }
    }, [getCities, setCities, fetchCities, hasError, loadingCities, auth, tenant]);

    useEffect(() => {
        if (!hasError && tenant?.itemId && !getDugs() && !loadingDugs) {
            fetchDugs({
                headers: generateHeaders(auth?.tokenData, tenant?.itemId, tenant?.id)
            })
                .then(res => {
                    setDugs(res?.data);
                })
                .catch(() => setHasErrors(true));
        }
    }, [getDugs, setDugs, fetchDugs, hasError, loadingDugs, auth, tenant]);

    useEffect(() => {
        if (!hasError && tenant?.itemId && !getCurrencies() && !loadingCurrencies) {
            fetchCurrencies({
                headers: generateHeaders(auth?.tokenData, tenant?.itemId, tenant?.id)
            })
                .then(res => {
                    setCurrencies(res?.data);
                })
                .catch(() => setHasErrors(true));
        }
    }, [getCurrencies, setCurrencies, fetchCurrencies, hasError, loadingCurrencies, auth, tenant]);

    useEffect(() => {
        if (!hasError && tenant?.itemId && !getAssets() && !loadingAssets) {
            fetchAssets({
                headers: generateHeaders(auth?.tokenData, tenant?.itemId, tenant?.id)
            })
                .then(res => {
                    setAssets(res?.data);
                })
                .catch(() => setHasErrors(true));
        }
    }, [getAssets, setAssets, fetchAssets, hasError, loadingAssets, auth, tenant]);

    return <>{children}</>;
};
